export const MBRestart = {
  restart: () => window.location.reload(),
};
